export default {
	path: '/danger-report-detail',
	redirect: '/danger-report-detail',
	component: () => import('@/views/layout/Default.empty'),
	children: [
		{
			path: '/',
			name: 'dangerReportDetailHome',
			component: () => import('@/views/main/DangerReportDetail'),
		},
	],
};
